import useAxios from 'hooks/useAxios';

/**
 * Get statistics for a custom date range or predefined period
 * @param {Object} params - Query parameters
 * @param {string} params.startDate - Start date (ISO 8601 format)
 * @param {string} params.endDate - End date (ISO 8601 format)
 * @param {string} params.period - Predefined period: 'daily', 'weekly', 'monthly', 'custom'
 * @param {boolean} params.includeComparison - Include comparison with previous period
 */
export async function getStatistics(params = {}) {
  const api = useAxios();

  try {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.period) queryParams.append('period', params.period);
    if (params.includeComparison !== undefined) {
      queryParams.append('includeComparison', params.includeComparison);
    }

    const res = await api.get(
      `/statistics?${queryParams.toString()}`,
    );
    return res;
  } catch (err) {
    return err;
  }
}
